import { IEmployee } from './../types/employee'
import * as constants from '../actions/constants'
import { DepartmentActions } from '../actions/departmentActions'
import { IDepartment, IPosition } from '../types/department'
import { IPagination } from '../../../types/pagination'

export const initialDepartments: IDepartment[] = [
  { id: '', name: '', hourly_rate: '0.00' }
]

const initialDepartmentsPagination: IPagination<IDepartment[]> = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: initialDepartments,
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}

export const _initialPosition: IPosition = {
  id: -1,
  name: '',
  department: '',
  department_name: ''
}

export const departments = (state: IDepartment[] = initialDepartments, action: DepartmentActions): IDepartment[] => {
  switch (action.type) {
    case constants.GET_DEPARTMENTS_SUCCESS:
      return action.departments

    case constants.UPDATE_DEPARTMENT_SUCCESS:
      return state.map(dep => {
        if (dep.id === action.department.id) {
          return action.department
        }
        return dep
      })

    case constants.CREATE_DEPARTMENT_SUCCESS:
      return [...state, action.department]

    case constants.DELETE_DEPARTMENT_SUCCESS:
      return state.filter(dep => dep.id !== action.department.id)

    default:
      return state
  }
}

export const sortDepartments = (state: { name: string, direction: string} = { name: '', direction: ''}, action: DepartmentActions): { name: string, direction: string } => {
  switch (action.type) {
    case constants.SORT_DEPARTMENTS:
      return action.sort

    default:
      return state
  }
}

export const employeesToDepartment = (state: IEmployee[] = [], action: DepartmentActions): IEmployee[] => {
  switch (action.type) {
    case constants.ADD_EMPLOYEES_TO_DEPARTMENT:
      return action.employees
    case constants.SELECTED_DEPARTMENT:
    case constants.GET_DEPARTMENT_SUCCESS:
      return action.department.employees ? action.department.employees : []

    default:
      return state
  }
}

export const department = (state: IDepartment = initialDepartments[0], action: DepartmentActions): IDepartment => {
  switch(action.type) {
    case constants.CREATE_DEPARTMENT_SUCCESS:
    case constants.UPDATE_DEPARTMENT_SUCCESS:
    case constants.SELECTED_DEPARTMENT:
      return action.department

    default:
      return state
  }
}

export const openDepartmentForm = (state = false, action: DepartmentActions): boolean => {
  switch (action.type) {
    case constants.OPEN_DEPARTMENT_FORM:
      return action.open
    case constants.CREATE_DEPARTMENT_SUCCESS:
    case constants.UPDATE_DEPARTMENT_SUCCESS:
      return false

    default:
      return state
  }
}

export const departmentActivePage = (state = 1, action: DepartmentActions): number => {
  switch (action.type) {
    case constants.SET_DEPARTMENT_ACTIVE_PAGE:
      return action.page

    default:
      return state
  }
}

export const filterDepartments = (state = '', action: DepartmentActions): string => {
  switch (action.type) {
    case constants.FILTER_DEPARTMENTS:
      return action.search

    default:
      return state
  }
}

export const departmentsPagination = (state: IPagination<IDepartment[]> = initialDepartmentsPagination, action: DepartmentActions): IPagination<IDepartment[]> => {
  switch (action.type) {
    case constants.GET_PAGINATED_DEPARTMENTS_SUCCESS:
      return action.departments

    default:
      return state
  }
}
